<div (finMutationObserver)="onDomChange($event)" #target></div>
<ng-container *ngIf="openChatTrigger$ | async as helpButtonStatus">
  <fin-pre-chat
    *ngIf="helpButtonStatus === HelpButtonStatus.CLICKED"
    (chatToggle)="chatTrigger($event)"
    (startChat)="startChat()"
  ></fin-pre-chat>

  <button
    *ngIf="helpButtonStatus === HelpButtonStatus.VISIBLE"
    id="chat-help-button"
    (click)="chatTrigger(HelpButtonStatus.CLICKED)"
    class="fixed flex flex--center nordic-blue-900-bg white-text ps-small-x ps-xsmall-y bold-type font-body-1 align-left rounded-left-large"
    [class.dirty]="dirty$ | async"
    tabindex="0"
    [attr.aria-label]="'chat.defaultMinimizedText' | finLocalization"
  >
    <fcom-icon class="flex--nogrow icon-medium white-text" name="chat" role="presentation"></fcom-icon>
    <span class="dn-tablet-down ms-xsmall-l">{{ 'chat.defaultMinimizedText' | finLocalization }}</span>
  </button>
</ng-container>
